var map = {
	".": "Dnow",
	"./": "Dnow",
	"./04_spot_trader_sell_order": "Zis6",
	"./04_spot_trader_sell_order.json": "Zis6",
	"./10_spot_trader_detail": "Zgby",
	"./10_spot_trader_detail.json": "Zgby",
	"./11_spot_trader_profit_summary": "sfhW",
	"./11_spot_trader_profit_summary.json": "sfhW",
	"./12_spot_trader_profit_detail": "2mJN",
	"./12_spot_trader_profit_detail.json": "2mJN",
	"./13_spot_trader_order_history": "3wC1",
	"./13_spot_trader_order_history.json": "3wC1",
	"./index": "Dnow",
	"./index.js": "Dnow"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0mC";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/copyTrade/api/spotTrader ^.*$
// module id = f0mC
// module chunks = 3